/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Carousel } from '@msdyn365-commerce/components';
import { Module } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { ICarouselViewProps } from './carousel';

/**
 * Returns item slots.
 * @returns Array of item slots.
 * @param props -Props.
 */
const retrieveItems = (props: ICarouselViewProps): React.ReactNode[] => {
    let items = [];
    items = props.slots && props.slots.content && props.slots.content.length > 0 ? props.slots.content : [];
    return items;
};
const CarouselView: React.FC<ICarouselViewProps> = props => (
    <Module {...props.carouselContainer} {...props.renderModuleAttributes(props)}>
        <Carousel
            className={classnames(props.closeAnimation)}
            activeIndex={props.activeIndex}
            next={props.next}
            previous={props.previous}
            pause={props.config.pauseOnHover ? 'hover' : false}
            ride={props.config.autoplay ? 'carousel' : undefined}
            autoplay={props.config.autoplay}
            interval={props.config.interval}
            transitionType={(props.config.transitionType) ? props.config.transitionType : undefined}
            items={retrieveItems(props)}
            hideFlipper={props.config.hideFlipper}
            dismissEnabled={props.config.dismissEnabled}
            onIndicatorsClickHandler={props.onIndicatorsClickHandler}
            handleDismissCarousel={props.handleDismissCarousel}
            dismissCarouselAriaText={props.resources && props.resources.ariaLabelForDismissButton}
            indicatorAriaText={props.resources && props.resources.ariaLabelForSlide}
            directionTextPrev={props.resources && props.resources.flipperPrevious}
            directionTextNext={props.resources && props.resources.flipperNext}
            handleOnExited={props.handleOnExited}
            handleOnExiting={props.handleOnExiting}
            telemetryContent={props.telemetryContent}
            keyboard={props.config.keyboard}
        />
    </Module>
);

export default CarouselView;
